



































import Vue from "vue";
import { UserOrganizationsAndTeams } from "@/types";

export default Vue.extend({
  name: "OrganizationSelectors",
  props: {
    organization: {
      type: Object as () => UserOrganizationsAndTeams,
      required: true
    }
  },
  methods: {
    emitClick(orgId: string, teamId: string, name: string) {
      this.$emit("select", { orgId, teamId, name });
    }
  }
});
